import { render, staticRenderFns } from "./user-agreement.vue?vue&type=template&id=78bba90b"
var script = {}
import style0 from "./user-agreement.vue?vue&type=style&index=0&id=78bba90b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports